import React, { useEffect } from 'react';
import Process from '../components/Process';
import FAQ from '../components/FAQ';

const ProcessPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-24 pb-12 w-full min-h-screen bg-slate-50">
      {/* SECTION 1: INTRODUCTION */}
      <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-12 pb-8">
        <div className="absolute top-4 left-4 z-50">
          <span className="text-[10px] font-mono tracking-widest text-slate-400 uppercase border border-slate-200 px-2 py-1 rounded">SECTION 1 — Process Introduction</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-slate-900 mb-6">How We Work</h1>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto">A transparent, streamlined process from initial discovery to final deployment.</p>
      </section>

      <Process />
      <FAQ />
    </div>
  );
};

export default ProcessPage;